module.exports = __webpack_public_path__ + "cced31c09e8f271cd34bc114c04e5829.png";